import React from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTextTranslation, getObject, imageAddress, pathMaker } from '../../utils/useful'
import TLink from '../TLink'
import FixedView from '../FixedView'

class TabelGlobalUserMultiInput extends React.Component {
    state = {
        data: {}
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data || prevProps.fullData != this.props.fullData) {
            this.init()
        }
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    init = () => {
        if (this.props.data) {
            let data = []
            // console.log('this.props.fullData',this.props.fullData)
            let usersInfo = getObject(this.props.fullData, 'populates.users')
            if (usersInfo && Array.isArray(usersInfo)) {
                usersInfo.map((element) => {
                    if (this.props.data.includes(element._id)) {
                        data.push(element)
                    }

                })
            }
            // this.props.data.map((element) => {
            //     console.log('elements',element,id)
            // })
            this.setState({ data })
        }
        // if (this.props.data) {
        //     if (typeof this.props.data != 'object') {
        //         this.fetchUser()
        //     }
        // } else {
        //     this.setState({ data: {} })
        // }
    }

    fetchUser = () => {
        let address = "getOneUserLimitedInfo"
        HttpServices.request(address, { id: this.props.data }, (fetchResult, fetchError) => {
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchResult?.info) {
                this.setState({ data: fetchResult.info })
            }
        })
    }


    oneUserView(data, fullInfo) {
        // console.log('data',data)
        // console.log('fullInfo',fullInfo)
        return (
            <div href={pathMaker('/' + data?.username)} target="_blank" className="w-100 h-100 flexc py-1" style={{ overflow: 'hidden' }}>
                <div className="flexcc">
                    <img src={imageAddress(data?.image, 'profile', 'small')} width={26} height={26} style={{ border: '1px solid #eee', borderRadius: 50, objectFit: 'cover' }} />
                </div>
                <div className="mld-2 w-100 " style={{ display: 'inline-block' }}>
                    {data?.username && (
                        <div>
                            <p className="font-size-13" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{data?.fullname}</p>
                            {fullInfo && (
                                <p className="font-size-12 " style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>@{data?.username}</p>
                            )}
                        </div>
                    )}

                    {(!data?.username && this.props.fullData) && (
                        <div>
                            <p className="font-size-13" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{this.props.fullData['*extra']?.name}</p>
                            {fullInfo && (
                                <p className="font-size-12 " style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>Virtual User</p>
                            )}
                        </div>
                    )}


                </div>
            </div>
        )
    }


    oneUserPhotoView(data) {
        return (
            <div className="flexc py-1" style={{ overflow: 'hidden' }}>
                <div className="flexcc">
                    <img src={imageAddress(data?.image, 'profile', 'small')} width={26} height={26} style={{ border: '1px solid #eee', borderRadius: 50, objectFit: 'cover' }} />
                </div>

            </div>
        )
    }



    render() {

        if (this.state.data && Array.isArray(this.state.data)) {
            let users = this.state.data
            // console.log(users)
            return (
                <div className='w-100'>

                    <div className='w-100  cursor-pointer' ref={el => this.currentNode = el} onClick={() => this.fixedView.showView()}>
                        {users.length == 1 && (
                            <div>
                                {this.oneUserView(users[0])}
                            </div>
                        )}

                        {users.length > 1 && (
                            <div className='flexc'>
                                {users.map((prop, index) => {
                                    return (
                                        this.oneUserPhotoView(prop)
                                    )
                                })}
                            </div>
                        )}
                    </div>


                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={() => { }} topOffset={0} bottomOffset={24} xOffset={-15} zIndex={15} width={200} >
                        <div className='br-6 px-2 py-1 position-relative' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 15px #10101020' }}>
                            {users.map((prop, index) => {
                                return (
                                    this.oneUserView(prop, true)
                                )
                            })}

                        </div>
                    </FixedView>

                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}

export default (TabelGlobalUserMultiInput);